import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";
import { lisbonNow } from "@/lib/time";

const SiteCtx = createContext(null);
const CACHE_KEY = "fsbe-bundle";

const index = (arr = []) => Object.fromEntries(arr.map((x) => [x.id, x]));

export function SiteProvider({ children }) {
  const [data, setData] = useState(() => { try { return JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { return null; } });
  const [edition, setEdition] = useState(null);
  const [error, setError] = useState(false);
  const [now, setNow] = useState(lisbonNow());

  const load = useCallback(async (slug) => {
    try {
      const { data: d } = await http.get("/public/bundle", { params: slug ? { edition: slug } : {} });
      setData(d);
      setError(false);
      if (!slug || d.edition.current) localStorage.setItem(CACHE_KEY, JSON.stringify(d));
    } catch { setError(true); }
  }, []);

  useEffect(() => { load(edition); }, [edition, load]);
  useEffect(() => { const t = setInterval(() => setNow(lisbonNow()), 30000); return () => clearInterval(t); }, []);

  const value = useMemo(() => {
    if (!data) return { data: null, error, load };
    const override = new URLSearchParams(window.location.search).get("agora") || data.settings?.now_override;
    const maps = { cats: index(data.categories), spaces: index(data.spaces), orgs: index(data.organizations), people: index(data.people), events: index(data.events) };
    const placeOf = (a) => maps.spaces[a.space_id]?.name || a.location_text || data.edition.location;
    return { data, error, load, ...maps, placeOf, now: override || now, simulated: !!override, setEdition, reload: () => load(edition) };
  }, [data, error, load, now, edition]);

  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
